import { rows } from "../lib/placeholder";
import { departmentKeys, colorVariants } from "../lib/colors";
import { Instructors } from "./instructors";

const Row = ({ subject, SYLLABUS_BASE_URL }) => {
    const departmentKey = departmentKeys[subject.department];
    const styles = colorVariants[departmentKey];
    const category = subject.subject_category + " / " + subject.registration_category;

    return (
        <tr className="hover:bg-indigo-50 dark:hover:bg-indigo-400/10 transition duration-150">
            <td className="px-4 py-3 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">{subject.grade}年</td>
            <td className="p-3 whitespace-nowrap text-sm text-start">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${styles.badge}`}>{subject.department}</span>
            </td>
            <td className="p-3 pr-9 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">{subject.semester}</td>
            <td className="p-3 whitespace-nowrap text-sm text-start font-semibold text-indigo-600 dark:text-indigo-300">
                {subject.syllabus_url ? (
                    <a href={`${SYLLABUS_BASE_URL}${subject.syllabus_url}`} target="_blank" rel="noopener noreferrer">
                        {subject.subject_name}
                    </a>
                ) : (
                    subject.subject_name
                )}
            </td>
            <td className="p-3 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">{category}</td>
            <td className="p-3 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">{subject.credit_type}</td>
            <td className="p-3 pr-4 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">
                {subject.credits}&nbsp;
                <span className="text-xs font-medium">単位</span>
            </td>
            <td className="p-3 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white"><Instructors instructors={subject.instructors} table={true} /></td>
            <td className="p-3 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">{subject.class_format}</td>
            <td className="p-3 pr-8 whitespace-nowrap text-sm text-start font-semibold text-gray-700 dark:text-white">
                {subject.classification ? subject.classification : '--'}
            </td>
        </tr>
    );
};

export const Table = ({ subjects, SYLLABUS_BASE_URL }) => {
    return (
        <div className="bg-white dark:bg-zinc-800/95 pb-2 rounded-2xl shadow-md w-full overflow-x-auto focus-within:outline-none focus-within:ring-2 focus-within:ring-blue-500 transition duration-150 ease-in-out">
            <table className="min-w-full p-2 divide-y divide-gray-200 dark:divide-zinc-500">
                <thead className="">
                    <tr>
                        {rows.map((row) =>
                            <th key={row.key} className="p-3 text-start text-xs font-semibold bg-gray-50 text-gray-500 dark:text-gray-100 dark:bg-zinc-700 tracking-wider">{row.value}</th>
                        )}
                    </tr>
                </thead>
                <tbody className="bg-white dark:bg-zinc-800/95 divide-y divide-gray-200 dark:divide-zinc-500">
                    {subjects.map((subject) =>
                        <Row key={subject.subject_id} subject={subject} SYLLABUS_BASE_URL={SYLLABUS_BASE_URL} />
                    )}
                </tbody>
            </table>
        </div>
    );
};